import React, { useEffect, useState } from "react";
import { paginatedCards } from "../../../api/apiServices";
import { useQuery } from "react-query";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";

function PaginatedCard() {
	const [currentPage, setCurrentPage] = useState(1);
	const [totalPages, setTotalPages] = useState(0);
	const [cards, setCards] = useState([]);
	const [postsPerPage] = useState(5); // Number of posts per page

	const {
		isLoading,
		isError,
		error,
		data: paginated_cards,
	} = useQuery(
		["paginated_cards", currentPage],
		() => paginatedCards(currentPage),
		{
			keepPreviousData: true,
			refetchOnMount: false,
			refetchOnWindowFocus: false,
		}, {
			onSuccess: async (res) => {
				// setIsLoading(false);
				    //  setCards(paginated_cards.cards);
        setTotalPages(res.totalPages);
			},
			onError: async (err) => {
				toast.error(err.message, {
					duration: 5000,
					className: "toast-message",
				});
				// setIsLoading(true);
				return false;
			},
		}
		);
	// if (paginated_cards) {
    //     setCards(paginated_cards.cards);
    //     setTotalPages(paginated_cards.totalPages);
    // }

	useEffect(() => {
		const fetchCards = async (page) => {
			try {
				await paginatedCards(page).then((result) => {
					setCards(result.cards);
					setTotalPages(result.totalPages);
				});
			} catch (error) {
				console.log(error);
			}
		};
		fetchCards(currentPage);
	}, [currentPage]);

	const pageNumbers = [];

	for (let i = 1; i <= Math.ceil(totalPages / postsPerPage); i++) {
		pageNumbers.push(i);
	}

	const handleClick = (e, number) => {
		e.preventDefault(); // Prevent default anchor behavior
		setCurrentPage(number);
	};

	const handlePrevPage = () => {
		if (currentPage > 1) {
			setCurrentPage(currentPage - 1);
		}
	};

	const handleNextPage = () => {
		if (currentPage < totalPages) {
			setCurrentPage(currentPage + 1);
		}
	};

   

	let content;
	if (isLoading) {
		content = <p>Loading Membership Cards...</p>;
	} else if (isError) {
		content = <p>{error.message}</p>;
	} else {
		content = (
			<div className="table-responsive lg">
				<table className="table table-bordered">
					<thead>
						<tr>
							<th scope="col" style={{ textAlign: "center" }}>
								#
							</th>
							<th scope="col">PF Number</th>
							<th scope="col">Name</th>
							<th scope="col">Region</th>
							<th scope="col">Printed</th>
							<th scope="col">issued</th>
							<th scope="col">Date issued</th>
							<th scope="col" style={{ textAlign: "center" }}>
								Action
							</th>
						</tr>
					</thead>
					<tbody>
						{paginated_cards?.cards.map((card, index) => (
							<tr key={card.id}>
								<td style={{ textAlign: "center" }}>
									{postsPerPage * (currentPage - 1) +
										index +
										1}
								</td>
								<td>{card.pf_number}</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{card.first_name}&nbsp;{card.middle_name}
									&nbsp;{card.last_name}
								</td>
								<td style={{ whiteSpace: "nowrap" }}>
									{card.region}
								</td>
								<td style={{ textAlign: "center" }}>
									{card.received_from_printer ? "YES" : "NO"}
								</td>
								<td style={{ textAlign: "center" }}>
									{card.issued_status ? "YES" : "NO"}
								</td>
								<td style={{ textAlign: "center" }}>
									{card.date_issued}
								</td>
								<td
									style={{
										textAlign: "center",
										whiteSpace: "nowrap",
									}}
								>
									<div style={{ display: "inline-block" }}>
										<Link
											to={`/view_card/${card.id}`}
											className="small"
										>
											<i className="fa fa-eye"></i> view
										</Link>
									</div>
									&nbsp; &nbsp;
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		);
	}

	return (
		<>
			<section className="content-header">
				<h1>Card Management - Global Cards</h1>
			</section>

			<section className="content">
				<div className="box">
					<div className="box-body">
						<div className="panel panel-default panel-br-4">
							<div className="row">
							</div>
							<hr />
							<div className="panel-heading">
								<div className="row">
									<div className="col-sm-12">
										<h4 className="panel-title">Cards</h4>
									</div>
								</div>
							</div>
							<div className="panel-body">{content}</div>
						</div>
					</div>
					<div className="box-footer">
						{/* Pagination controls */}
						<nav>
							<ul className="pagination">
								<li
									onClick={handlePrevPage}
									disabled={currentPage === 1}
								>
									<Link
										disabled={currentPage === 1}
										className="page-link"
									>
										Previous
									</Link>
								</li>
								{pageNumbers.map((number) => (
									<li
										key={number}
										className={`page-item ${
											currentPage === number
												? "active"
												: ""
										}`}
									>
										<a
											onClick={(e) =>
												handleClick(e, number)
											} // Added e.preventDefault()
											href="!#"
											className="page-link"
										>
											{number}
										</a>
									</li>
								))}
								<li
									onClick={handleNextPage}
									disabled={currentPage === totalPages}
								>
									<Link className="page-link">Next</Link>
								</li>
							</ul>
						</nav>
					</div>
				</div>
			</section>
		</>
	);
}

export default PaginatedCard;
